import { render, staticRenderFns } from "./doctorDetails.vue?vue&type=template&id=a99e05f4&"
import script from "./doctorDetails.vue?vue&type=script&lang=js&"
export * from "./doctorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports